export const UploadETicketsDraggableSource = 'UploadETicketsDraggableSource';
